/**
 * Suprime persistência de mute/unmute transitório enquanto o fundo virtual
 * (ou outro processor) reinicia tracks. Sem isso, TrackMuted vira
 * audioEnabled/videoEnabled=false no localStorage e a reconexão deixa
 * mic/câmera desligados.
 */

export const MEDIA_MUTATION_GRACE_MS = 2_500;

let depth = 0;
let graceUntilMs = 0;

export function resetMediaMutationGuard(): void {
  depth = 0;
  graceUntilMs = 0;
}

export function beginMediaMutationGuard(): void {
  depth += 1;
}

export function endMediaMutationGuard(graceMs: number = MEDIA_MUTATION_GRACE_MS): void {
  depth = Math.max(0, depth - 1);
  if (depth === 0) {
    const safeGrace = Number.isFinite(graceMs) && graceMs >= 0 ? graceMs : MEDIA_MUTATION_GRACE_MS;
    graceUntilMs = Date.now() + safeGrace;
  }
}

export function isMediaMutationSuppressed(now: number = Date.now()): boolean {
  return depth > 0 || now < graceUntilMs;
}

/**
 * Remove audioEnabled/videoEnabled do update quando o guard está ativo.
 * Mantém troca de device. Retorna null se não restar nada para persistir.
 */
export function stripMediaTogglesIfSuppressed<
  T extends { audioEnabled?: boolean; videoEnabled?: boolean },
>(update: T, suppressed: boolean): T | null {
  if (!suppressed) {
    return update;
  }

  const next = { ...update };
  delete next.audioEnabled;
  delete next.videoEnabled;

  const hasPayload = (Object.keys(next) as Array<keyof T>).some(
    (key) => next[key] !== undefined,
  );
  return hasPayload ? next : null;
}
